var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "#00449e",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.09,6.86L23.14.91c-.6-.6-1.4-.91-2.19-.91s-1.58.3-2.19.91L.91,18.76C.32,19.34,0,20.13,0,20.95v5.96c0,1.71,1.39,3.09,3.1,3.09h5.95c.82,0,1.61-.33,2.19-.91L29.09,11.24c1.21-1.21,1.21-3.17,0-4.37ZM3.1,22.79c1.74.95,3.17,2.38,4.12,4.12H3.1v-4.12Zm7.03,3.04c-1.3-2.57-3.39-4.66-5.96-5.96L20.95,3.09l5.96,5.96L10.13,25.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateButton);
export default __webpack_public_path__ + "static/media/updateButton.8ff4a3fadae2f33c6231335f8756bb39.svg";
export { ForwardRef as ReactComponent };